<template>
    <div id="App" class="container-fluid">
        <transition name="slide-fade">
            <ScreenLock v-if="!(userIsAuthenticated)"/>
        </transition>
        <SiteHeader v-if="userIsAuthenticated"/>
        <PageContent v-if="userIsAuthenticated"/>
    </div>
</template>

<script>
    // import all components here
    import SiteHeader from './layout/header/SiteHeader.vue'
    import PageContent from './layout/PageContent.vue'
    import ScreenLock from './layout/ScreenLock.vue'


    export default {
        name: 'App',
        components: {
            SiteHeader,
            PageContent,
            ScreenLock
        },
        data: () => ({
            UtilityNavs:[],
            moduleNavs:[],
            breadCrumbs:[
                {name: 'home', route: '/home'}
            ]
        }),
        created() {
            this.$api
                .get('sanctum/csrf-cookie', {}, 'none')
                .then(() => this.$store.dispatch('Auth/authenticate', this.$router.resolve({path: '/authenticate/azuread'}).href));
        },
        mounted() {
            this.$store.commit('Navigation/setUtilities', this.$data.UtilityNavs);
            this.$store.commit('Navigation/setBreadcrumbs', this.$data.breadCrumbs);;
        },
        computed: {
            userIsAuthenticated(){
                return this.$store.getters['Auth/id'] ? true : false
            }
        }

    }
</script>
<style>
    @font-face {
        font-family: "Graphik";
        src: local("Rubik"),
        url(../../assets/fonts/Rubik/static/Rubik-Regular.ttf) format("truetype");
    }
    @font-face {
        font-family: "SFUIText";
        src: local("SFUIText"),
        url(../../assets/fonts/SFUIText/SFUIText-Regular.woff) format("woff");
    }
    @font-face {
        font-family: "HelveticaNeue";
        src: local("HelveticaNeue"),
        url(../../assets/fonts/HelveticaNeue/HelveticaNeue Medium.ttf) format("truetype");
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: "HelveticaNeue";
        src: local("HelveticaNeue"),
        url(../../assets/fonts/HelveticaNeue/HelveticaNeue Medium.ttf) format("truetype");
        font-weight: 500;
        font-style: normal;
    }
    @font-face {
        font-family: "AktivGrotesk";
        src: local("AktivGrotesk"),
        url(../../assets/fonts/AktivGrotesk/aktiv-grotesk-w01.ttf) format("truetype");
        font-weight: bold;
        font-style: normal;
    }
    @font-face {
        font-family: "Metropolis";
        src: local("Metropolis"),
        url(../../assets/fonts/Metropolis/Metropolis-Regular.otf) format("opentype");
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: "SalesforceSans";
        src: url(../../assets/fonts/salesforceSans/salesforce-sans.eot);
        src: url(../../assets/fonts/salesforceSans/salesforce-sans.woff2) format("woff2"),
        url(../../assets/fonts/salesforceSans/salesforce-sans.woff) format("woff"),
        url(../../assets/fonts/salesforceSans/salesforce-sans.ttf) format("truetype");
        font-weight: normal;
        font-style: normal;
    }
</style>
